// react
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { url } from "../../helper";

export default function FooterNewsletter() {
    const [email, Setemail] = useState();
    const [success, SetSuccess] = useState();
    const [loading, setLoading] = useState(false);

    const hnadlarChange = (event) => {
        Setemail(event.target.value);
    };

    const handlerClick = (event) => {
        event.preventDefault();
        setLoading(true);

        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            fetch(`${url}/api/subscribe`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ subscriber_email: email }),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.success) {
                        setLoading(false);
                        SetSuccess({ message: data.success, class: "text-success" });
                    } else {
                        setLoading(false);
                        SetSuccess({ message: data.error, class: "text-danger" });
                    }
                })
                .catch((error) => console.error(error, "error"))
                .finally((res) => {
                    Setemail("");
                });
        } else {
            setLoading(false);
            SetSuccess({ message: "Invalid Email", class: "text-danger" });
        }
    };
    return (
        <div>
            <h5 className="footer-newsletter__title">
                <FormattedMessage id="footer.subscribe" defaultMessage="Բաժանորդագրվել" />
            </h5>

            <form action="" className="footer-newsletter__form">
                <label className="sr-only" htmlFor="footer-newsletter-address">
                    <FormattedMessage id="topbar.email" defaultMessage="էլ․ Հասցե" />
                </label>
                <FormattedMessage id="topbar.email" defaultMessage="էլ․ Հասցե">
                    {(placeholder) => (
                        <input
                            type="text"
                            onChange={hnadlarChange}
                            value={email}
                            className="footer-newsletter__form-input form-control"
                            id="footer-newsletter-address"
                            placeholder={placeholder}
                        />
                    )}
                </FormattedMessage>
                {success ? (
                    <small id="passwordHelp" className={success.class}>
                        {success.message}
                    </small>
                ) : (
                    ""
                )}
                <button
                    onClick={handlerClick}
                    type="submit"
                    className={
                        !loading
                            ? "footer-newsletter__form-button sub-button-fms btn btn-primary"
                            : "btn btn-primary btn-loading sub-button-fms footer-newsletter__form-button"
                    }
                >
                    <FormattedMessage id="footer.subscribe" defaultMessage="Բաժանորդագրվել" />
                </button>
            </form>
        </div>
    );
}
